import config from "../config";
import RequestManager from "./request";
export default class Fse {
    constructor(obj) {
        this.numFse = obj.numFse || "string";
        this.numLot = obj.numLot || "string";
        this.numSecSoc = obj.numSecSoc || "string";
        this.nomPatient = obj.nomPatient || "string";
        this.dateFse = obj.dateFse || "string";
        this.pour_praticien = obj.pour_praticien || 0;
        this.fse_Tla = obj.fse_Tla || true;
        this.modeRechercheLot = obj.modeRechercheLot || 0;
        this.selectionToutesFse = obj.selectionToutesFse || true;
        this.selectionSecuriseOuSsVitale = obj.selectionSecuriseOuSsVitale || true;
        this.selectionNonSecuriseOuDegrades = obj.selectionNonSecuriseOuDegrades || true;
        this.selectionDesynchronisees = obj.selectionDesynchronisees || true;
        this.selectionNonSignees = obj.selectionNonSignees || true;
        this.selectionSignees = obj.selectionSignees || true;
        this.selectionTransEnCours = obj.selectionTransEnCours || true;
        this.selectionTraitees = obj.selectionTraitees || true;
        this.selectionRefusees = obj.selectionRefusees || true;
    }

    static getFSE(FSE) {
        var url = config.urlBackEnd + 'Prat/GetPratByNumLicence?NUMERO_LICENCE=' + NUMERO_LICENCE;
        url = encodeURI(url)
        return RequestManager.get(url)
            .then(response => { return response; });
    }

    static getSaisieFSE() {
        var url = config.urlBackEnd + 'FSE/getSaisieFSE';
        url = encodeURI(url)
        return RequestManager.get(url)
            .then(response => { return response; });
    }

    static async setFacfse(newFacfse) {
        try {
            let url = `${config.urlBackEnd}FSE/setFacFSE`;
            url = encodeURI(url);

            // POST avec les données
            const response = await RequestManager.post(url, newFacfse);
            return response;
        } catch (error) {
            console.error("Error on script/Fse setFacfse", error);
            throw error;
        }
    }

    static async getFacfse() {
        try {
            const url = `${config.urlBackEnd}FSE/getFacFSE`;
            const response = await RequestManager.get(url);
            return response;
        } catch (error) {
            console.error("Error on script/Fse getFacfse", error);
            throw error;
        }
    }

    // Saisie d'acte : pousse les prestations (codes saisis dans Presta_Renamed) au backend qui
    // les decompose et calcule quantite/coefficient/denombrement/base de remboursement/montant.
    // Retourne le tableau prest enrichi (a afficher : Montantpaye, baseremb...). C'est l'appel
    // "a la saisie" (equivalent LostFocus), a ne pas confondre avec l'enregistrement.
    static async saisirActe(prest) {
        try {
            const url = `${config.urlBackEnd}FSE/saisirActe`;
            return await RequestManager.post(url, prest);
        } catch (error) {
            console.error("Error on script/Fse saisirActe", error);
            throw error;
        }
    }

    static async enregistrerFse(formsoin) {
        try {
            const url = `${config.urlBackEnd}FSE/enregistrerFse`;
            return await RequestManager.post(url, formsoin);
        } catch (error) {
            console.error("Error on script/Fse enregistrerFse", error);
            throw error;
        }
    }

    // Instance Formsoin serveur (PascalCase). Porte notamment le bandeau reglementaire ADR
    // (UtiliseAdrText / UtiliseAdrTextVisible), positionne lors du flux VITALE/ADR cote backend
    // (cf Interface_pour_library_transCAM_sortie). Equivalent desktop : Formsoin.FormSoin_Instance.
    static async getFormsoinInstance() {
        try {
            const url = `${config.urlBackEnd}Formsoin/getFormsoinInstance`;
            return await RequestManager.get(url);
        } catch (error) {
            console.error("Error on script/Fse getFormsoinInstance", error);
            throw error;
        }
    }

    // FSE en mode degrade (patient choisi dans la liste, sans carte VITALE) : prepare cote backend
    // la structure VITALE degradee + benec a partir de l'identifiant patient, sinon l'enregistrement
    // est refuse ("Il faut au moins choisir un patient Ou bien lire une carte VITALE").
    // Retourne { success, benec, message } (le resolver backend sort en PascalCase -> on gere les 2).
    static async chargerPatientDegrade(identPatient) {
        const url = `${config.urlBackEnd}FSE/chargerPatientDegrade?identPatient=${encodeURIComponent(identPatient)}`;
        return RequestManager.post(url);
    }
}
